import {
  toast_styles_default
} from "./chunk.Z4TBN4EL.js";
import {
  emit
} from "./chunk.C4ZTYQN4.js";
import {
  HasSlotController
} from "./chunk.CLKP6Z3C.js";
import {
  SlAlert
} from "./chunk.BBHA2P2S.js";
import {
  o
} from "./chunk.OBPYZVEK.js";
import {
  e,
  i,
  n
} from "./chunk.D5EJUUKV.js";
import {
  $,
  w
} from "./chunk.4JTBA2KG.js";
import {
  __decorateClass
} from "./chunk.K2NRSETB.js";

// src/components/toast/toast.ts
var FadvToast = class extends SlAlert {
  constructor() {
    super(...arguments);
    this.hasSlot = new HasSlotController(this, "[default]", "header", "prefix", "suffix");
    this.confirmActionLabel = "";
    this.dismissActionLabel = "";
    this.heading = "";
    this.message = "";
  }
  handleConfirmActionClick() {
    emit(this, "fadv-toast-confirmed");
    this.open = false;
  }
  handleDismissActionClick() {
    emit(this, "fadv-toast-dismissed");
    this.open = false;
  }
  renderConfirmActionButton() {
    if (!this.confirmActionLabel)
      return w;
    return $`<span class="toast__button"><button class="toast__confirm-button" @click=${this.handleConfirmActionClick}><fadv-typography type="label-x-small">${this.confirmActionLabel}</fadv-typography></button></span>`;
  }
  renderDismissActionButton() {
    if (!this.dismissActionLabel)
      return w;
    return $`<span class="toast__button"><button class="toast__dismiss-button" @click=${this.handleDismissActionClick}><fadv-typography type="label-x-small">${this.dismissActionLabel}</fadv-typography></button></span>`;
  }
  renderHeader() {
    if (this.heading)
      return $`<fadv-typography type="label-small" weight="500">${this.heading}</fadv-typography>`;
    return $`<slot name="header"></slot>`;
  }
  renderMessage() {
    const type = this.hasSlot.test("header") || this.heading ? "paragraph-small" : "paragraph-large";
    const content = this.message ? this.message : $`<slot></slot>`;
    return $`<fadv-typography type=${type}>${content}</fadv-typography>`;
  }
  toast() {
    return new Promise((resolve) => {
      const toastStack = document.querySelector("fadv-toast-outlet");
      if (!toastStack)
        return;
      toastStack.appendChild(this);
      requestAnimationFrame(() => {
        this.clientWidth;
        this.show();
      });
      this.addEventListener("sl-after-hide", () => {
        toastStack.removeChild(this);
        resolve();
      }, { once: true });
    });
  }
  connectedCallback() {
    super.connectedCallback();
  }
  render() {
    return $`<div part="base" class=${o({
      toast: true,
      "toast--open": this.open,
      "toast--primary": this.variant === "primary",
      "toast--success": this.variant === "success",
      "toast--neutral": this.variant === "neutral",
      "toast--warning": this.variant === "warning",
      "toast--danger": this.variant === "danger",
      "toast--secondary": this.variant === "secondary",
      "toast--tertiary": this.variant === "tertiary",
      "toast--has-header": this.hasSlot.test("header") || this.heading,
      "toast--has-prefix": this.hasSlot.test("prefix"),
      "toast--has-suffix": this.hasSlot.test("suffix"),
      "toast--has-button": !!this.confirmActionLabel || !!this.dismissActionLabel
    })} role="alert" aria-live="assertive" aria-atomic="true" aria-hidden=${this.open ? "false" : "true"} @mousemove=${this.handleMouseMove} ><div class="toast__content"><div part="header" class="toast__header">${this.renderHeader()}</div><div part="body" class="toast__body"><span part="prefix" class="toast__icon toast__prefix"><slot name="prefix"></slot></span><span part="message" class="toast__message">${this.renderMessage()}</span><span part="suffix" class="toast__icon toast__suffix"><slot name="suffix"></slot></span></div></div><div class="toast__buttons">${this.renderConfirmActionButton()}${this.renderDismissActionButton()}</div></div>`;
  }
};
FadvToast.styles = toast_styles_default;
__decorateClass([
  e({ reflect: true })
], FadvToast.prototype, "confirmActionLabel", 2);
__decorateClass([
  e({ reflect: true })
], FadvToast.prototype, "dismissActionLabel", 2);
__decorateClass([
  e({ reflect: true })
], FadvToast.prototype, "heading", 2);
__decorateClass([
  e({ reflect: true })
], FadvToast.prototype, "message", 2);
__decorateClass([
  i(".toast")
], FadvToast.prototype, "toastElement", 2);
FadvToast = __decorateClass([
  n("fadv-toast")
], FadvToast);

export {
  FadvToast
};
